import axios from "axios";
import { attachAuthInterceptors } from "./attachAuthInterceptors";

const apiPaymentsClient = axios.create({
    baseURL:process.env.REACT_APP_API_PAYMENTS,
    timeout: 30000
    // withCredentials: true
})

attachAuthInterceptors(apiPaymentsClient);

export default apiPaymentsClient